<template>
    <div>
        <div class="d-flex flex-row justify-content-center gap-3 mb-8">
            <div class="text-center">
                <h2 class="mb-0"> {{ priceComparisonTitle }} </h2>
                <h2 class="mt-3" v-if="initFilters.category">{{ __('statistics.in_category', {'category': this.initFilters.category}) }}</h2>
            </div>
            <Tooltip class="w-300px" position="left">
                <template #trigger>
                    <i class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
                </template>
                <div v-html="priceComparisonInfo"></div>
            </Tooltip>
        </div>
        <div v-show="!metricsIsEmpty">
            <PriceSegmentationBar
                class="my-8"
                :below-min-count="statistics.MC[$page.props.store.id].counts[PriceSegment.BELOW_COMPARISON]"
                :in-range-count="statistics.MC[$page.props.store.id].counts[PriceSegment.IN_COMPARISON]"
                :above-max-count="statistics.MC[$page.props.store.id].counts[PriceSegment.ABOVE_COMPARISON]">
            </PriceSegmentationBar>

            <div class="row">
                <div class="col-xl-4 col-md-6">
                    <div class="form-group">
                        <select ref="select" v-model="selectedPriceSegment" @change="onFilterChange($event,'priceSegmentFilter')"
                                class="selectpicker w-100"
                                data-style="btn btn-default text-dark"
                                id="k_form_price"
                                tabindex="-97">
                            <option :value="null">
                                {{ __('statistics..price_comparison.all_price_spans') }}
                            </option>
                            <option :value="PriceSegment.BELOW_COMPARISON">
                                {{ __(`statistics.price_comparison.${PriceSegment.BELOW_COMPARISON}`) }}
                            </option>
                            <option :value="PriceSegment.IN_COMPARISON">
                                {{ __(`statistics.price_comparison.${PriceSegment.IN_COMPARISON}`) }}
                            </option>
                            <option :value="PriceSegment.ABOVE_COMPARISON">
                                {{ __(`statistics.price_comparison.${PriceSegment.ABOVE_COMPARISON}`) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <ArticlesWithPricesTable
                :statistics="statistics.MC[$page.props.store.id].pagination"
                :total-stats="statistics.MC[$page.props.store.id].counts"
                :category="initFilters.category"
                @reloadStats="fetchData">
            </ArticlesWithPricesTable>
        </div>
        <p v-show="metricsIsEmpty" class="text-center text-xl mt-4">{{ __('statistics.impressions_empty_for_filters') }}</p>
    </div>
</template>

<script>
import StatisticsLayout from '@layouts/Statistics/StatisticsLayout.vue';
import ArticlesWithPricesTable from '@components/Stats/Components/ArticlesWithPricesTable.vue';
import PriceSegmentationBar from '@components/Stats/Components/PriceSegmentationBar.vue';
import {PriceSegment} from '@generated/priceSegment';
import {InventoryStatus} from '@generated/inventoryStatus';
import Tooltip from '@components/Tooltip.vue';

export default {
    components: {Tooltip, PriceSegmentationBar, ArticlesWithPricesTable},
    layout: StatisticsLayout,

    props: {
        statistics: Object,
        initFilters: Object,
        inventoryStatus: String,
    },

    data() {
        return {
            selectedPriceSegment: this.initFilters.priceSegmentFilter,
        };
    },

    mounted() {
        $(this.$refs.select).selectpicker();
    },

    methods: {
        fetchData() {
            this.$inertia.reload({only: ['initFilters', 'statistics']});
        },
        onFilterChange(event, filterField) {
            this.$parent.$emit('slotFilterChanged', {field: filterField, value: event.target.value});
        },
    },

    computed: {
        PriceSegment() {
            return PriceSegment;
        },
        metricsIsEmpty() {
            return this.statistics.MC[this.$page.props.store.id].pagination.data.length === 0;
        },

        priceComparisonTitle() {
            if (this.inventoryStatus === InventoryStatus.OUT_OF_STOCK) {
                return this.__('statistics.price_comparison.title_out_of_stock');
            } else {
                return this.__('statistics.price_comparison.title');
            }
        },

        priceComparisonInfo() {
            if (this.inventoryStatus === InventoryStatus.OUT_OF_STOCK) {
                return this.__('statistics.price_comparison.info_out_of_stock');
            } else {
                return this.__('statistics.price_comparison.info');
            }
        },
    },
};
</script>
